import { BaseFetch } from "../main-model"
export default class GpaModel extends BaseFetch {
    getGpaBy = (data) =>
    this.authFetch({
      url: "gpa/getGpaBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getGpaById = (data) =>
    this.authFetch({
      url: "gpa/getGpaById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertGpa = (data) =>
    this.authFetch({
      url: "gpa/insertGpa",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateGpaById = (data) =>
    this.authFetch({
      url: "gpa/updateGpaById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteGpaById = (data) =>
    this.authFetch({
      url: "gpa/deleteGpaById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
